import { useCallback, useState } from 'react';

const DEFAULT_IMPORT_LOADING_CONTENT = {
  title: 'Sorting moments...',
  subtitle: 'Separating dated moments and related details for review. Longer notes can take a few seconds.',
};

export const useImportReviewUiState = () => {
  const [showImportStartModal, setShowImportStartModal] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [importLoadingContent, setImportLoadingContent] = useState(DEFAULT_IMPORT_LOADING_CONTENT);
  const [importError, setImportError] = useState('');
  const [importStatus, setImportStatus] = useState('');

  const openImportStartModal = useCallback(() => {
    setImportStatus('');
    setShowImportStartModal(true);
  }, []);

  const closeImportStartModal = useCallback(() => {
    setShowImportStartModal(false);
  }, []);

  const startImportLoading = useCallback((content = {}) => {
    setImportStatus('');
    setImportLoadingContent({
      title: content.title || DEFAULT_IMPORT_LOADING_CONTENT.title,
      subtitle: content.subtitle || DEFAULT_IMPORT_LOADING_CONTENT.subtitle,
    });
    setImportLoading(true);
  }, []);

  const stopImportLoading = useCallback(() => {
    setImportLoading(false);
  }, []);

  const clearImportError = useCallback(() => {
    setImportError('');
  }, []);

  const clearImportStatus = useCallback(() => {
    setImportStatus('');
  }, []);

  return {
    showImportStartModal,
    importLoading,
    importLoadingContent,
    importError,
    importStatus,
    setImportError,
    setImportStatus,
    openImportStartModal,
    closeImportStartModal,
    startImportLoading,
    stopImportLoading,
    clearImportError,
    clearImportStatus,
  };
};

export default useImportReviewUiState;
